<template>
  <footer class="footer">

    <FloatingActionButton />

    <div class="footer-container">
      <div class="footer-column">
        <h4>EKU MARKET</h4>
        <p>
          EKU Market is a digital platform where users earn as they spend time
          engaging online.
        </p>
        <!-- <a href="#">About Us</a>
        <a href="#">Contact Us</a>
        <a href="#">Privacy Policy</a> -->
      </div>

      <div class="footer-column">
        <h5>Quick Links</h5>
        <a href="https://liveonlineradio.net/eku-fm">EKU FM</a>
        <router-link to="/term&conditions" class="nav-link">Terms & Conditions</router-link>
        <router-link to="/about" class="nav-link">About</router-link>
        <a href="#">Affiliates</a>
      </div>
      <div class="footer-column">
        <h5>Join Us</h5>
        <form @submit.prevent>
          <input type="email" placeholder="Your Email" class="footer-input" />
          <button type="submit" class="footer-btn">Subscribe</button>
        </form>
      </div>
    </div>

    <hr class="footer-divider" />
    <p class="footer-bottom">
      &copy; {{ currentYear }} EKU MARKET. All rights reserved.
    </p>
  </footer>
</template>

<script setup>

import { computed } from 'vue';
import FloatingActionButton from "../components/FloatingMenu.vue";


const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.footer {
  background-color: #222;
  color: #fff;
  padding: 40px 20px;
  font-family: "Segoe UI", sans-serif;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.footer-column {
  flex: 1 1 250px;
  margin: 10px 20px;
}

.footer-column h4,
.footer-column h5 {
  margin-bottom: 15px;
  color: #00cc99;
}

.footer-column a {
  display: block;
  color: #ccc;
  margin: 8px 0;
  text-decoration: none;
  transition: 0.3s ease;
}

.footer-column a:hover {
  color: #fff;
  text-decoration: underline;
}

.footer-input {
  padding: 10px;
  border: none;
  border-radius: 5px;
  margin-right: 10px;
  width: 70%;
}

.footer-btn {
  padding: 10px 15px;
  background-color: #00cc99;
  border: none;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.footer-btn:hover {
  background-color: #00aa88;
}

.footer-divider {
  border-color: #444;
  margin: 30px 0 10px;
}

.footer-bottom {
  text-align: center;
  font-size: 14px;
  color: #aaa;
}
</style>
